import { Search } from "lucide-react";

export default function EmptyState({ icon: Icon = Search, title, description, action, testId = "empty-state" }) {
  return (
    <div
      data-testid={testId}
      className="bg-white border-2 border-dashed border-border rounded-sm p-12 text-center"
    >
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-ivory-100 mb-4">
        <Icon size={20} className="text-gold-600" strokeWidth={1.5} />
      </div>
      <h3 className="font-serif text-xl text-navy-900">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto leading-relaxed">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
